import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment.prod';

@Injectable({
  providedIn: 'root',
})
export class CreditsService {
  private creditsSubject = new BehaviorSubject<any>(null);
  credits$ = this.creditsSubject.asObservable();

  constructor(private http: HttpClient) {}

  private getHeaders() {
    const token = localStorage.getItem('access_token');
    return { Authorization: `Bearer ${token}` };
  }

  // API Call
  getCredits(): Observable<any> {
    return this.http.get(`${environment._url}/api/billings/credits/`, {
      headers: this.getHeaders(),
    });
  }

  // Load + Broadcast credits
  loadCredits() {
    this.getCredits().subscribe((res: any) => {
      const credits = res[0];
      this.creditsSubject.next(credits);
    });
  }

  // Optional manual set
  setCredits(credits: any) {
    this.creditsSubject.next(credits);
  }

  getFeatureCosts(): Observable<any> {
    return this.http.get(`${environment._url}/api/billings/feature-costs/`, {
      headers: this.getHeaders(),
    });
  }

  getTransactionsDetails(params?: any): Observable<any> {
    let query = '';

    if (params?.date_filter) {
      query += `?date_filter=${params.date_filter}`;
    }

    if (params?.week_start) {
      query += `?week_start=${params.week_start}`;
    }

    return this.http.get(
      `${environment._url}/api/billings/transactions/${query}`,
      { headers: this.getHeaders() },
    );
  }
}
